const Recruiting = () => {
	return (
		<h1>Mee töihin :-D</h1>
	)
}

export default Recruiting;